import { ChevronDown } from "lucide-react";

export const Input = ({
  label,
  name,
  value,
  onValueChange,
  icon: Icon,
  error,
  textarea = false,
  ...props
}) => {
  const Comp = textarea ? "textarea" : "input";

  return (
    <div className="space-y-2">
      <label className="text-xs font-semibold uppercase text-slate-500 dark:text-slate-400">
        {label}
      </label>

      <div
        className={`relative rounded-xl border ${
          error ? "border-red-400" : "border-slate-200 dark:border-slate-700"
        } bg-white dark:bg-slate-900 focus-within:ring-2 focus-within:ring-teal-500`}
      >
        {Icon && (
          <Icon className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
        )}

        <Comp
          {...props}
          value={value ?? ""}
          onFocus={(e) => {
            if (props.type === "number" && value === 0) {
              e.target.select();
            }
          }}
          onChange={(e) => onValueChange?.(name, e.target.value)}
          className={`w-full bg-transparent px-3 py-2.5 text-sm text-slate-900 dark:text-white outline-none ${
            Icon ? "pl-10" : ""
          } ${textarea ? "min-h-[124px]" : ""}`}
        />
      </div>

      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};

export const SelectInput = ({
  label,
  name,
  value,
  onValueChange,
  icon: Icon,
  error,
  options = [],
  placeholder = "Select",
  className = "",
  ...props
}) => {
  return (
    <div className="space-y-2">
      {label && (
        <label className="text-xs font-semibold uppercase text-slate-500 dark:text-slate-400">
          {label}
        </label>
      )}

      <div
        className={`relative rounded-xl border ${
          error ? "border-red-400" : "border-slate-200 dark:border-slate-700"
        } bg-white dark:bg-slate-900 focus-within:ring-2 focus-within:ring-teal-500`}
      >
        {Icon && (
          <Icon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 pointer-events-none" />
        )}

        <select
          {...props}
          value={value ?? ""}
          onChange={(e) => onValueChange?.(name, e.target.value)}
          className={`w-full appearance-none rounded-xl bg-white dark:bg-slate-900 py-2.5 pr-10 text-sm text-slate-900 outline-none dark:text-white ${
            Icon ? "pl-10" : "pl-3"
          } ${className}`}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>

          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <ChevronDown className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 pointer-events-none" />
      </div>

      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};
